/**
 * Created by BFR on 21/08/2017.
 */
define('historyPopupView',[
    'underscore',
    'app',
    'settings',
    'module',
    'template!historyTablePopupViewTpl',
    'template!historyPopupViewTpl',
    'dialogFormView',
    'jqgridView'
], function (_,
             App,
             Settings,
             module,
             viewTpl,
             productTpl,
             DialogFormView,
             JqGridView
             ) {
    'use strict';

    var HistoryTableView = JqGridView.extend({
        template: productTpl,
        filtersName: 'historySelectionListFilters',

        ui: function () {
            return _.extend({
                jqGrid: '#jq-grid-list-dialog',
                jqGridPager: '#jq-grid-pager-list-dialog'
            }, this.gridUi);
        },

        imagePopoverContainer: '.history-dialog',

        events: function() {
            return _.extend({
            }, this.gridEvents);
        },

        serializeData: function () {
            return {type: 'product'};
        },

        gridOptions: function (data) {
            var that = this,
                defaultsOptions, options;

            defaultsOptions = this.gridInitOptions(data);
            options = {
                colModel: [
                    {label: '', name: 'secId', key: true, hidden: true},
                    {
                        label: _.i18n('history.user'),
                        name: 'refUserpid',
                        align: 'left',
                        search: false,
                        classes: 'history-link',
                        formatter: this.userFormatter,
                        width: 100
                    },
                    {
                        label: _.i18n('history.creatDate'),
                        name: 'creatDate',
                        align: 'left',
                        search: false,
                        classes: 'history-link',
                        formatter: this.dateTimeFormatter,
                        width: 130
                    },
                    {
                        label: _.i18n('history.field'),
                        name: 'field',
                        align: 'left',
                        search: false,
                        classes: 'history-link',
                        formatter: _.bind(this.fieldFormatter, this)
                    },
                    {
                        label: _.i18n('history.oldValue'),
                        name: 'oldValue.value',
                        search: false,
                        index: 'productCode',
                        classes: 'history-link',
                        formatter: _.bind(this.valueFormatter, this)
                    },
                    {
                        label: _.i18n('history.newValue'),
                        name: 'value',
                        search: false,
                        classes: 'history-link',
                        formatter: _.bind(this.valueFormatter, this)
                    }
                ],

                gridComplete: function() {
                    that.onGridComplete();
                    that.hidePopovers();
                    that.attachPopover();
                }
            };

            options = _.defaults(options, defaultsOptions);
            options.sortname = 'creatDate';
            options.sortorder = 'desc';

            return options;
        },

        fieldFormatter: function(field, options) {
            field = _.i18n('history.field.' + field);
            return this.defaultFormatter(field, options);
        },

        valueFormatter: function(value, options, object) {
            switch(object.field) {
                case 'refUser': return this.userFormatter(value);
                case 'urgent':
                case 'flagged':
                case 'ontop': return _.i18n('common.' + (value?'yes':'no'));
                case 'ticketState': return _.i18n('vectorization.status.' + value.toLowerCase());
                case 'ticketType':
                    switch(value.toLowerCase()) {
                        case 'vectorization': return _.i18n('vectorization');
                        case 'conversion': return _.i18n('conversion.title');
                        case 'remove_background': return _.i18n('backRemove.title');
                        case 'colorization': return _.i18n('colorization.title');
                    }
                    return _.i18n('ticketType.' + value.toLowerCase());
            }
            return this.defaultFormatter(value, options);
        }
    });

    var HistoryView = DialogFormView.extend({
        template: viewTpl,

        className: 'product-selection-dialog',

        regions: {
            historyRegion: '.history-region'
        },

        ui: {
            'leave' : '.leave-button',
            'blinder':'#dialog-blinder'
        },

        events: {
            'click @ui.leave' : 'leavePopup'
        },

        onShow: function () {
            App.regions.addRegions(this.regions);
            this.historyTableView = new HistoryTableView();
            this.historyTableView.listenTo(this.historyTableView, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            App.regions.getRegion('historyRegion').show(this.historyTableView);
        },

        serializeData: function() {
            if (typeof this.options.displayLeaveButton === 'boolean') {
                this.displayLeaveButton = this.options.displayLeaveButton;
            } else {
                this.displayLeaveButton = true;
            }
            return {displayLeaveButton: this.displayLeaveButton};
        },

        onBlind: function() {
            this.ui.blinder.show();
        },

        onBlindEnd: function() {
            this.ui.blinder.hide();
        },

        onGridLoaded: function () {
            var data = {
                url: this.options.url,
                rowCountUrl: this.options.rowCountUrl
            };
            this.historyTableView.displayGrid(data, true);
        },

        leavePopup: function() {
            this.hide();
        }
    });

    module.exports = HistoryView;
});
